// extracted by mini-css-extract-plugin
module.exports =  {"row":"_02712f2b3b--row--LerJb","key":"_02712f2b3b--key--Sb38i","value":"_02712f2b3b--value--nzxPf","warning":"_02712f2b3b--warning--vPwaC"};